import ActionsForm from '@/shared/mixins/actionsForm'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  mixins: [ActionsForm],
  name: 'tablePrice',
  props: ['searchFilter'],
  data () {
    return {
      dataUnidade: null,
      consultaenterprise: [],
      dataFilter: localStoreHelper.gestao.tabelaPreco() || [],
      selectedEnterprise: {},
      title: 'Buscar Relatório',
      columns: ['EMPREENDIMENTOS', 'CIDADE', 'UF', 'QTD. DE FORMAS DE PAGAMENTO', 'DT. ÚLTIMA ATUALIZAÇÃO'],
      filterOn: false
    }
  },
  watch: {
    searchFilter (newvalue, oldvalue) {
      let filterOn = false
      Object.keys(newvalue).forEach((Element) => {
        if (this.searchFilter[Element] !== null) filterOn = true
      })
      if (filterOn) {
        this.searchWithFilter()
      } else {
        this.onLoad()
      }
      this.filterOn = filterOn
    }
  },
  methods: {
    onLoad () {
      if (Object.keys(this.dataFilter).length === 0) {
        EnterpriseRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(Response => {
            this.dataUnidade = Response.data.data
            this.$refs.tableGrid.LoadAllByData(Response)
          })
          .catch(() => {})
      } else {
        this.getFilter()
      }
    },
    searchWithFilter (newEnterpriseArray, newResponse) {
      this.dataUnidade = newEnterpriseArray
      this.$refs.tableGrid.LoadAllByData(newResponse)
    },
    getFilter () {
      loading.push()
      EnterpriseRepository.GetEmpreendimentoByFiltro(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.dataFilter)
        .then(Response => {
          this.dataUnidade = Response.data.data
          this.$refs.tableGrid.LoadAllByData(Response)
          loading.pop()
        })
        .catch(Error => loading.pop())
    }
    // searchWithFilter () {
    //   EnterpriseRepository.searchWithFilter(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.searchFilter)
    //     .then(Response => {
    //       this.dataUnidade = Response.data.data
    //       this.$refs.tableGrid.LoadAllByData(Response)
    //     })
    //     .catch(() => {})
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/pricetablemanagement/components/tablePrice/tablePrice.js